import { createLogger } from '@svs/nova-core/log';

/**
 * Central logger instances for the payment-sport package.
 * Each logger is scoped to a specific domain/component.
 */

export const logger = createLogger('payment');
